import { render, staticRenderFns } from "./MyCollection.vue?vue&type=template&id=2145ab6c&"
import script from "./MyCollection.vue?vue&type=script&lang=js&"
export * from "./MyCollection.vue?vue&type=script&lang=js&"
import style0 from "./MyCollection.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports